class VideoPlayer {
    constructor(videoSelector, playButtonSelector, headlineSelector, soundButtons, muteButton, unmuteButton) {
        this.videos = document.querySelectorAll(videoSelector);
        this.playButton = document.getElementById(playButtonSelector);
        this.headlineVideos = document.querySelectorAll(headlineSelector);
        this.soundButtons = document.querySelector(soundButtons);
        this.muteBtn = document.querySelector(muteButton);
        this.unMuteBtn = document.querySelector(unmuteButton);
        this.thumbnails = document.querySelectorAll(".image-wrapper .thumbnail_image");
        this.init();
    }

    init() {
        this.videos.forEach((video, index) => {
            video.addEventListener('click', () => {
                this.togglePlay(video)

                if (this.soundButtons) {
                    this.soundButtons.addEventListener('click', () => {
                        this.toggleMute(video)
                    })    
                }
            });
        });

        this.thumbnails.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => {
                thumbnail.style.display = 'none';
                this.playVideo(this.videos[index]);
            });
        });
    }

    togglePlay(video) {
        if (video.paused || video.ended) {
            this.playVideo(video);
            if (this.soundButtons) {
                this.soundButtons.style.display = 'block';
            }
        } else {
            this.pauseVideo(video);
            if (this.soundButtons) {
                this.soundButtons.style.display = 'none';
            }
        }
    }

    toggleMute(video) {
        if(video.muted){
            video.muted = false
            this.muteBtn.classList.add('hidden');
            this.unMuteBtn.classList.remove('hidden');
        }else{
            video.muted = true
            this.muteBtn.classList.remove('hidden');
            this.unMuteBtn.classList.add('hidden');
        }
    }

    playVideo(video) {
        video.play();
        video.muted = false;
        this.playButton.style.visibility = "hidden";
        if (document.body.classList.contains('template-product')) {
            if (this.headlineVideos.length > 0) {
                this.headlineVideos[0].style.visibility = "hidden";
            }    
        }
    }

    pauseVideo(video) {
        video.pause();
        video.muted = true;
        this.playButton.style.visibility = "visible";
        if (document.body.classList.contains('template-product')) {
            if (this.headlineVideos.length > 0) {
                this.headlineVideos[0].style.visibility = "visible";
            }    
        }
    }
}

const videoPlayer = new VideoPlayer('.video-element', 'play-button', '.headline-video', '.sound-buttons', '.mute-btn', '.unmute-btn' );
